export const isIos = () => !!window.webkit?.messageHandlers?.firebase

export const isAndroid = () => !!window.NavigatorWebInterface

export const isNativeApp = () => isIos() || isAndroid()
